"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function TableLoader({ tableLoaderStyle, testId = "" }) {
    return (react_1.default.createElement(style_1.TableLoaderWrapper, { sx: tableLoaderStyle, "data-testid": testId },
        react_1.default.createElement(style_1.TitleLoader, { variant: "rectangular" }),
        react_1.default.createElement(style_1.Table, { variant: "rectangular" })));
}
exports.default = TableLoader;
